import { render, staticRenderFns } from "./AuthenticCard.vue?vue&type=template&id=64d14c76&scoped=true&"
import script from "./AuthenticCard.vue?vue&type=script&lang=ts&"
export * from "./AuthenticCard.vue?vue&type=script&lang=ts&"
import style0 from "./AuthenticCard.vue?vue&type=style&index=0&id=64d14c76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d14c76",
  null
  
)

export default component.exports